import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {   getHistoricalSharesAction } from "../actions";
import { historicalSharesSelector, } from "../store/slice/trade";

/**
 *
 * @returns {[{
 *  historicalShareList: (import("../..").historicalShareList)[],
 *  loading: boolean,
 *  error: object,
 * }, {
 *  getHistoricalShares: () => void
 * }]}
 */
const useHistoricalShares = () => {
  const dispatch = useDispatch();

  const getHistoricalShares = useCallback(queryData => dispatch(getHistoricalSharesAction(queryData)), [dispatch]);
  const historicalShares= useSelector(historicalSharesSelector);

  return  { getHistoricalShares, historicalShares };
};



export default useHistoricalShares;
